import React, { useState } from 'react';
import API from '../../ApiService/ApiService';
import Context from './index';
import Widget from '../../Helpers/Widget';

const SalesmanProvider = (props) => {
  const api = new API();
  
  const [tableFilter, setTableFilter] = useState({
    name: '',
    page: 1,
    limit: 10
  });

  const [listLoader, setListLoader] = useState(false);
  const [addLoader, setAddLoader] = useState(false);
  const [editLoader, setEditLoader] = useState(false);
  const [deleteLoader, setDeleteLoader] = useState(false);
  
  const [salesmanList, setSalesmanList] = useState([]);
  const [singleSalesmanLoader, setSingleSalesmanLoader] = useState(false);
  const [viewSingleSalesman, setViewSingleSalesman] = useState({});
  const [singleSalesmanId, setSingleSalesmanId] = useState(null);
  
  const [salesmanForm, setSalesmanForm] = useState({
    name: "",
    username: "",
    password: "",
    phone: "",
    email: "",
    address: "",
    coupons: [],
    commission_percentage: 0
  });

  const fetchSalesmanList = async () => {
    setListLoader(true);
    if(localStorage.getItem("rxdx_admin_login") === "true") {
      await api.getAll("salesagent", {...tableFilter}, (err, res) => {    
        if (res?.data?.status === 200) {
          setSalesmanList(res?.data?.data);
        } else {
          setSalesmanList([]);
        }
        setListLoader(false);
      });
    } else {
      setListLoader(false);
    }
  };

  const getSingleSalesman = async (id) => {
    setSingleSalesmanLoader(true);
    if(localStorage.getItem("rxdx_admin_login") === "true") {
      await api.getSingle("salesagent/single", id, (err, res) => {    
        if (res?.data?.status === 200) {
          setSingleSalesmanId(res?.data?.data?._id);
          setViewSingleSalesman(res?.data?.data);
          setSalesmanForm({
            ...res?.data?.data,
            password: "", // hide password
            coupons: res?.data?.data?.coupons?.map(c => c._id) || []
          });
        } else {
          setViewSingleSalesman({});
          setSalesmanForm({});
        }
        setSingleSalesmanLoader(false);
      });
    } else {
      setSingleSalesmanLoader(false);
    }
  };

  const addSalesman = async (data) => {
    setAddLoader(true);
    const result = localStorage.getItem("rxdx_admin_login") === "true" && await api.create("salesagent", data, (err, res) => {    
      if(err) {
        Widget.showMessage("error", err?.response?.data?.message || "Failed to add account");
      }
      setAddLoader(false);
    });
    return result;
  };

  const editSalesman = async (data, id) => {
    setEditLoader(true);
    const result = localStorage.getItem("rxdx_admin_login") === "true" && await api.update("salesagent", id, data, (err, res) => {
      if (err) {
        Widget.showMessage("error", err?.response?.data?.message || "Failed to edit account");
      }
      setEditLoader(false);
    });
    return result;
  };

  const statusUpdateSalesman = async (status = null, id = null) => {
    if (!id) return Widget.showMessage("error", "ID is required");
    if (status === null || status === "" || status === undefined) return Widget.showMessage("error", "Status is required");
    
    const res = localStorage.getItem("rxdx_admin_login") && api.update("salesagent/status", id, { status: status }, (err, res) => {
      if (res) {
        Widget.showMessage("success", res?.data?.message);
        fetchSalesmanList();
      } else {
        Widget.showMessage("error", err?.response?.data?.message);
      }
    });
    return res;
  };

  const deleteSalesman = async (id) => {
    setDeleteLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" && await api.remove("salesagent", id, (err, res) => {    
      if (res?.data?.status === 200) {
        Widget.showMessage("success", res?.data?.message);
        fetchSalesmanList();
      } else {
        Widget.showMessage("error", err?.response?.data?.message);
      }
      setDeleteLoader(false);
    });
  };

  return (
    <Context.Provider
      value={{
        ...props,
        salesmanList, setSalesmanList, fetchSalesmanList,
        tableFilter, setTableFilter,
        listLoader, setListLoader,
        addLoader, setAddLoader, addSalesman,
        editLoader, setEditLoader, editSalesman,
        salesmanForm, setSalesmanForm,
        singleSalesmanLoader, setSingleSalesmanLoader, getSingleSalesman,
        singleSalesmanId, setSingleSalesmanId,
        viewSingleSalesman, setViewSingleSalesman,
        statusUpdateSalesman,
        deleteLoader, setDeleteLoader, deleteSalesman
      }}
    >
      {props.children}
    </Context.Provider>
  );
};

export default SalesmanProvider;
